// extracted by mini-css-extract-plugin
module.exports = {"timelineWrapper":"LWwZq","timeline":"_2HQJZ","isLoading":"qStEi","timelineInner":"B5XL+","middle":"lKV1o","redLine":"V8Agk","left":"Ug3PP","right":"UxpJj"};